import { url as searchURL } from '../index';
import ApiService from '@api/api-service';

export const url = `${searchURL}`;
export default new ApiService(url);
